import {Button} from 'platform/components';
import {HStack, VStack} from 'platform/foundation';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {DmsDataGrid, refreshDmsDatagrid} from '@dms/shared';

import {Nullish, TestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface RequestsTabProps extends TestIdProps {
  itemId: string | Nullish;
}

export function RequestsTab(props: RequestsTabProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) =>
      mergeAll([
        filter,
        {
          originEntityId: props.itemId,
        },
      ]),
    [props.itemId]
  );

  return (
    <VStack spacing={0}>
      <DmsDataGrid
        gridCode="service-order-item-requests"
        autoHeight={true}
        queryModifier={queryModifier}
        data-testid={suffixTestId('requests-dg', props)}
      />
      <HStack justify="flex-start">
        <Button
          variant="link"
          title={i18n.t('general.actions.refresh')}
          leftIcon="navigation/refresh"
          onClick={() => refreshDmsDatagrid('service-order-item-requests')}
          data-testid={suffixTestId('requestsAction.refresh', props)}
        />
      </HStack>
    </VStack>
  );
}
